/** Marketing page sx. Same pixels as the old Bootstrap Agency template. */

const SERIF =
  "'Droid Serif', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
const SANS =
  "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"

export const marketingSectionSx = {
  py: '50px',
}

export const marketingHeadingSx = {
  fontSize: 40,
  mt: 0,
  mb: '15px',
  fontWeight: 700,
  textTransform: 'uppercase',
}

export const marketingSubheadingSx = {
  fontSize: 16,
  fontWeight: 400,
  fontStyle: 'italic',
  mb: '75px',
  textTransform: 'none',
  fontFamily: SERIF,
}

export const marketingProcessStepSx = {
  mb: '50px',
  textAlign: 'center',
  '& img': {
    width: 225,
    height: 225,
    border: '7px solid rgba(0, 0, 0, 0.1)',
  },
}

export const introTextSx = {
  pt: { xs: '48px', md: '100px' },
  pb: { xs: '32px', md: '50px' },
  flexShrink: 0,
  px: 2,
}

export const introLeadInSx = {
  fontSize: { xs: 22, md: 40 },
  fontStyle: 'italic',
  lineHeight: 1.2,
  mb: '25px',
  fontFamily: SERIF,
  color: '#fff',
}

export const introHeadingSx = {
  fontSize: { xs: 32, sm: 48, md: 64, lg: 75 },
  fontWeight: 700,
  lineHeight: 1.15,
  mb: { xs: '16px', md: '50px' },
  fontFamily: SANS,
  textTransform: 'uppercase',
  color: '#fff',
  WebkitTextFillColor: '#fff',
  textShadow: 'none',
  whiteSpace: { xs: 'normal', md: 'nowrap' },
}

export const marketingFieldGroupSx = {
  mb: '25px',
}

export const marketingFieldSx = {
  display: 'block',
  width: '100%',
  boxSizing: 'border-box',
  p: '20px',
  height: 'auto',
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: 1.5,
  color: '#495057',
  backgroundColor: '#fff',
  border: '1px solid #ced4da',
  borderRadius: '0.25rem',
  '&:focus': {
    borderColor: '#00a4e4',
    boxShadow: 'none',
    outline: 'none',
  },
  '&::placeholder': {
    fontWeight: 700,
    color: '#ced4da',
    fontFamily: SANS,
  },
}

export const marketingTextareaSx = {
  ...marketingFieldSx,
  height: 248,
}

export const marketingFieldHintSx = {
  display: 'block',
  mt: '0.25rem',
}

export const marketingLeadSx = {
  fontSize: '1.25rem',
  color: '#a6a6b9',
}

export const marketingContactHeadingSx = {
  ...marketingHeadingSx,
  color: '#fff',
}

export const marketingHeroSx = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundImage: 'linear-gradient(135deg, #97ABFF 10%, #123597 100%) !important',
}

export const marketingHeroLayerSx = {
  flexGrow: 1,
  display: 'flex',
  zIndex: 6,
  width: '100%',
  alignItems: 'center',
}

export const marketingHeroImageSx = {
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  width: '100%',
  zIndex: 3,
  opacity: 0.15,
  filter: 'grayscale(80%)',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
}

export const marketingHeroOverlaySx = {
  position: 'absolute',
  left: 0,
  top: 0,
  height: '100%',
  width: '100%',
  zIndex: 5,
  opacity: 0.15,
  backgroundImage: 'linear-gradient(to right, #434343 0%, black 100%) !important',
}

export const marketingHeroCopySx = {
  position: 'relative',
  zIndex: 7,
  width: '100%',
}

export const marketingHeroTitleSx = {
  fontWeight: 300,
  fontSize: '2.5rem',
  lineHeight: 1.2,
}

export const marketingHeroSubtitleSx = {
  py: '1rem',
  color: 'rgba(255, 255, 255, 0.5)',
  fontSize: '1.265rem !important',
}

export const marketingHeroBodySx = {
  color: 'rgba(255, 255, 255, 0.5)',
  mb: '1.5rem',
  fontSize: '1.15rem !important',
}

export const marketingCtaSx = {
  borderRadius: '4.5rem',
  boxShadow:
    '0 0.46875rem 2.1875rem rgba(7, 9, 25, 0.03), 0 0.9375rem 1.40625rem rgba(7, 9, 25, 0.03), 0 0.25rem 0.53125rem rgba(7, 9, 25, 0.05), 0 0.125rem 0.1875rem rgba(7, 9, 25, 0.03) !important',
  color: '#fff',
  backgroundColor: '#f4772e',
  backgroundImage: 'none',
  borderColor: '#f4772e',
  '&:not(:disabled):hover': {
    backgroundColor: '#f4772e',
    color: '#fff',
  },
}

export const marketingCtaLabelSx = {
  display: 'inline-block',
}
